import forOwn from 'mout/object/forOwn'
import destructureSubtests from './destructureSubtests'
import initializeByNodeScoring from './initializeByNodeScoring'
import initializeByItemScoring from './initializeByItemScoring'
import initializeBySubtestScoring from './initializeBySubtestScoring'
import initializeByTestScoring from './initializeByTestScoring'

/**
 * Creates a new groupUA object based on the assessment structure.
 * @param {string} assessmentId The set id of the assessment.
 * @param {object} sets All of the sets in db.collection('sets').
 * @param {object} items All of the items in db.collection('contentItems').
 * @param {string} userId The userId of the active user.
 * @returns {object} A new groupUA object for db.collection('groupUA')
 */
export default function initializeNewGroupUA(assessmentId, sets, items, userId, groupType, schoolYear) {

  const assessmentSet = Object.assign({}, sets[assessmentId])

  //create assessmentSubtests
  let assessmentSubtests = {}
  forOwn(assessmentSet.content, (val, key, o) => {
    if (sets[key] && val.active) {
      let displayName
      sets[key].displayName ? displayName = sets[key].displayName : displayName = sets[key].name
      const thisSet = sets[key]
      let maxNodeLevels = 0
      let maxRaw = 0
      let nodeTag = ''
      let testType = 'Subtest'
      let timeLimit = 0
      let rawToScaleScoring = {0: 0}
      let directions = ''
      let sectionBreaks = []
      let timeManagementEasy = null
      let timeManagementHard = null
      let precisionQuestions = null
      let precisionComparables = null
      let dataRepresentationPassages = null
      let researchSummaryPassages = null
      let conflictingViewpointsPassages = null
      /*
        dataRepresentationPassages: dataR,
        researchSummaryPassages: researchS,
        conflictingViewpointsPassages: confV,
      */

      thisSet.maxNodeLevels ? maxNodeLevels = thisSet.maxNodeLevels : null
      thisSet.maxRaw ? maxRaw = thisSet.maxRaw : null
      thisSet.nodeTag ? nodeTag = thisSet.nodeTag : null
      thisSet.testType ? testType = thisSet.testType : null
      thisSet.timeLimit ? timeLimit = thisSet.timeLimit : null
      thisSet.rawToScaleScoring ? rawToScaleScoring = thisSet.rawToScaleScoring : null
      thisSet.directions ? directions = thisSet.directions : null
      thisSet.sectionBreaks ? sectionBreaks = thisSet.sectionBreaks : null
      thisSet.timeManagementEasy ? timeManagementEasy = thisSet.timeManagementEasy : null
      thisSet.timeManagementHard ? timeManagementHard = thisSet.timeManagementHard : null
      thisSet.precisionQuestions ? precisionQuestions = thisSet.precisionQuestions : null
      thisSet.precisionComparables ? precisionComparables = thisSet.precisionComparables : null
      thisSet.dataRepresentationPassages ? dataRepresentationPassages = thisSet.dataRepresentationPassages : null
      thisSet.researchSummaryPassages ? researchSummaryPassages = thisSet.researchSummaryPassages : null
      thisSet.conflictingViewpointsPassages ? conflictingViewpointsPassages = thisSet.conflictingViewpointsPassages : null

      assessmentSubtests[key] = {
        name: sets[key].name,
        setId: key,
        displayName,
        index: val.index,
        content: sets[key].content,
        displayName,
        maxNodeLevels, 
        maxRaw,
        nodeTag,
        testType,
        timeLimit,
        rawToScaleScoring,
        directions,
        sectionBreaks,
        timeManagementEasy,
        timeManagementHard,
        precisionQuestions,
        precisionComparables,
        dataRepresentationPassages,
        researchSummaryPassages,
        conflictingViewpointsPassages,
      }
    }
  })

  //create destructuredSubtests
  const destructuredSubtests = destructureSubtests(sets, assessmentSubtests)         

  // Create byNode 
  const byNode = initializeByNodeScoring(items, destructuredSubtests)

  // Create byItem
  const byItem = initializeByItemScoring(destructuredSubtests)

  // Create bySubtest
  const bySubtest = initializeBySubtestScoring(byItem)

  // Create byTest
  const byTest = initializeByTestScoring(bySubtest)

  let newGroupUA = {
      assessmentId,
      assessmentSet,
      assessmentSubtests,
      destructuredSubtests,
      scoring: {
        byNode,
        bySubtest,
        byTest,
        byItem,
      },
      students: {},
      groupType: groupType,
      groupId: userId,
      year: schoolYear,
      upToDate: true,
      lastUpdated: Date.now(),
  }

  let answersByItem = {}      
        forOwn(newGroupUA.assessmentSet.content, (subtest, key) => {
          if (subtest.active) {
            answersByItem[key] = {}
          }
        })
        newGroupUA.answersByItem = answersByItem;   

  return newGroupUA;
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/initializeNewGroupUA.js